module.exports = __webpack_public_path__ + "img/WechatIMG30254.a43adf39.jpg";